import * as t from "io-ts";
import nullable from "./nullable";
import { cargoEquipmentRoleT, positiveIntegerT } from "./cargo-equipment";
import { placeT } from "./place";
export const equipmentCategoryValues = [
    "CONTAINER",
    "PLATE",
    "MACHINE",
    "POLE",
    "SCAFFOLDING",
    "TOOL",
    "OTHER",
];
export const equipmentCategoryT = t.union([
    t.literal("CONTAINER"),
    t.literal("PLATE"),
    t.literal("MACHINE"),
    t.literal("POLE"),
    t.literal("SCAFFOLDING"),
    t.literal("TOOL"),
    t.literal("OTHER"),
]);
export const equipmentStatusValues = [
    "AVAILABLE",
    "PLANNED",
    "IN_TRANSIT",
    "WITH_CUSTOMER",
    "UNDER_SERVICE",
    "UNAVAILABLE",
    "SOLD",
];
export const equipmentStatusT = t.union([
    t.literal("AVAILABLE"),
    t.literal("PLANNED"),
    t.literal("IN_TRANSIT"),
    t.literal("WITH_CUSTOMER"),
    t.literal("UNDER_SERVICE"),
    t.literal("UNAVAILABLE"),
    t.literal("SOLD"),
]);
export const equipmentConditionValues = [
    "EXCELLENT",
    "GOOD",
    "FAIR",
    "POOR",
    "DAMAGED",
];
export const equipmentConditionT = t.union([
    t.literal("EXCELLENT"),
    t.literal("GOOD"),
    t.literal("FAIR"),
    t.literal("POOR"),
    t.literal("DAMAGED"),
]);
export const baseEquipmentDepotT = t.strict({
    name: t.string,
    address: nullable(t.string),
    postcode: nullable(t.string),
    city: nullable(t.string),
    country: nullable(t.string),
    lat: t.number,
    lon: t.number,
    note: nullable(t.string),
});
export const equipmentDepotT = t.intersection([
    baseEquipmentDepotT,
    t.strict({ id: t.string, archived: t.boolean }),
]);
export const equipmentDepotsT = t.array(equipmentDepotT);
export const equipmentOverviewRowT = t.strict({
    id: t.string,
    number: nullable(t.string),
    serialNumber: nullable(t.string),
    quantity: t.number,
    status: equipmentStatusT,
    condition: equipmentConditionT,
    equipmentTypeId: nullable(t.string),
    equipmentTypeName: nullable(t.string),
    category: nullable(equipmentCategoryT),
    currentClientId: nullable(t.string),
    currentClientName: nullable(t.string),
    currentPlaceName: nullable(t.string),
    homeLocation: nullable(t.string),
    depotId: nullable(t.string),
    depotName: nullable(t.string),
    outSince: nullable(t.string),
    note: nullable(t.string),
    activeRentalId: nullable(t.string),
    activeRentalNumber: nullable(t.string),
    lat: nullable(t.number),
    lon: nullable(t.number),
    canBeEmptied: t.boolean,
    plannedJobs: t.array(t.strict({
        cargoId: t.string,
        cargoRef: nullable(t.string),
        role: cargoEquipmentRoleT,
        date: nullable(t.string),
    })),
});
export const equipmentOverviewT = t.array(equipmentOverviewRowT);
export const equipmentActiveRentalT = t.strict({
    equipmentId: t.string,
    rentalNumber: t.string,
});
export const equipmentActiveRentalsT = t.array(equipmentActiveRentalT);
export const updateEquipmentNoteT = t.strict({ note: nullable(t.string) });
export const equipmentHistoryRowT = t.strict({
    id: t.string,
    equipmentId: t.string,
    cargoId: nullable(t.string),
    rentalId: nullable(t.string),
    eventType: t.string,
    eventDate: t.string,
    fromStatus: nullable(t.string),
    toStatus: nullable(t.string),
    clientId: nullable(t.string),
    note: nullable(t.string),
    performedBy: nullable(t.string),
});
export const equipmentHistoryT = t.array(equipmentHistoryRowT);
export const equipmentAtSiteT = t.strict({
    equipmentId: t.string,
    number: nullable(t.string),
    equipmentTypeName: nullable(t.string),
    status: equipmentStatusT,
    clientName: nullable(t.string),
});
export const equipmentNearStopT = t.intersection([
    equipmentAtSiteT,
    t.strict({
        distanceMeters: t.number,
        onThisCargo: t.boolean,
    }),
]);
export const equipmentsNearStopT = t.array(equipmentNearStopT);
export const siteJobKindT = t.union([
    t.literal("EMPTY"),
    t.literal("END_RENTAL"),
]);
export const equipmentJobKindT = t.union([siteJobKindT, t.literal("DELIVER")]);
export const createEquipmentJobTypes = ({ date = t.string, } = {}) => ({
    createEquipmentJobT: t.strict({
        kind: equipmentJobKindT,
        date,
        note: nullable(t.string),
        emptyingPlace: nullable(placeT),
        clientId: nullable(t.string),
        deliveryPlace: nullable(placeT),
    }),
});
export const createEquipmentJobT = createEquipmentJobTypes().createEquipmentJobT;
export const equipmentJobResultT = t.strict({
    cargoId: t.string,
    rentalId: nullable(t.string),
    invoiceLineAdded: t.boolean,
});
export const siteJobPlaceT = t.strict({
    placeName: nullable(t.string),
    address: nullable(t.string),
    postcode: nullable(t.string),
    city: nullable(t.string),
    country: nullable(t.string),
    lat: t.number,
    lon: t.number,
});
export const createSiteJobTypes = ({ date = t.string, } = {}) => ({
    createSiteJobT: t.strict({
        kind: siteJobKindT,
        date,
        note: nullable(t.string),
        clientId: t.string,
        plannedQuantity: positiveIntegerT,
        equipmentIds: t.array(t.string),
        place: siteJobPlaceT,
        destination: nullable(siteJobPlaceT),
        emptyingPlace: nullable(siteJobPlaceT),
    }),
});
export const createSiteJobT = createSiteJobTypes().createSiteJobT;
export const siteJobOrderT = t.strict({
    cargoId: t.string,
    equipmentId: nullable(t.string),
    equipmentNumber: nullable(t.string),
    equipmentTypeName: nullable(t.string),
    completed: t.boolean,
});
export const siteJobT = t.strict({
    id: t.string,
    kind: siteJobKindT,
    date: t.string,
    note: nullable(t.string),
    clientId: nullable(t.string),
    plannedQuantity: t.number,
    place: siteJobPlaceT,
    destination: nullable(siteJobPlaceT),
    createdAt: t.string,
    orders: t.array(siteJobOrderT),
});
export const siteJobsT = t.array(siteJobT);
export const cancelSiteJobResultT = t.strict({
    id: t.string,
    deletedCargoIds: t.array(t.string),
    keptCargoIds: t.array(t.string),
});
export const createEquipmentTypes = ({ decimal, }) => {
    const baseEquipmentTypeT = t.strict({
        name: t.string,
        category: equipmentCategoryT,
        isNumbered: t.boolean,
        canBeEmptied: t.boolean,
        defaultDailyPrice: nullable(decimal),
        defaultWeeklyPrice: nullable(decimal),
        defaultMonthlyPrice: nullable(decimal),
        defaultDeliveryFee: nullable(decimal),
        defaultPickupFee: nullable(decimal),
        defaultEmptyingPrice: nullable(decimal),
        color: nullable(t.string),
        icon: nullable(t.string),
        note: nullable(t.string),
        rentalProductId: nullable(t.string),
        emptyingProductId: nullable(t.string),
        returnProductId: nullable(t.string),
    });
    const updateEquipmentTypeT = t.intersection([
        baseEquipmentTypeT,
        t.strict({ id: t.string }),
    ]);
    const equipmentTypeT = updateEquipmentTypeT;
    const equipmentTypesT = t.array(equipmentTypeT);
    const baseEquipmentT = t.strict({
        equipmentTypeId: nullable(t.string),
        number: nullable(t.string),
        serialNumber: nullable(t.string),
        quantity: t.number,
        status: equipmentStatusT,
        condition: equipmentConditionT,
        ownWeight: nullable(decimal),
        depotId: nullable(t.string),
        homeLocation: nullable(t.string),
        homeLat: nullable(t.number),
        homeLon: nullable(t.number),
        note: nullable(t.string),
    });
    const updateEquipmentT = t.intersection([
        baseEquipmentT,
        t.strict({ id: t.string }),
    ]);
    const equipmentT = updateEquipmentT;
    const equipmentsT = t.array(equipmentT);
    return {
        baseEquipmentTypeT,
        updateEquipmentTypeT,
        equipmentTypeT,
        equipmentTypesT,
        baseEquipmentT,
        updateEquipmentT,
        equipmentT,
        equipmentsT,
    };
};
//# sourceMappingURL=equipment.js.map